import ApiService from './ApiService'

export default class PopDocumentService {
  constructor() {
    this.apiService = new ApiService()
  }

  async deleteSelectedItens(vm) {
    const ids = vm.downloadList.map((file) => file.id)
    if (!ids.length) {
      vm.$toast.error(vm.$t('Nenhum item selecionado para exclusão.'))
      return
    }
    try {
      const response = await this.apiService.delete('PopDocument/delete-selected-files', ids)
      if (response.statusCode === 200) {
        vm.downloadList = []
        vm.showSelectedOptions = false
        await vm.loadData()
        vm.$toast.success(vm.$t('Itens selecionados excluídos com sucesso!'))
      } else {
        vm.$toast.error(vm.$t('Erro ao excluir os itens selecionados.'))
      }
    } catch (error) {
      console.error('Erro ao excluir os itens selecionados:', error)
      vm.$toast.error(vm.$t('Erro ao excluir os itens selecionados.'))
    }
  }

  async getDocument(vm, document) {
    try {
      const response = await this.apiService.get(`uploadDocument/${document.id}`)
      if (response.statusCode === 200) {
        const fileWindow = window.open()
        const url = 'data:application/pdf;base64,' + response.content.filepath
        fileWindow.document.write(
          `<html>
            <title>${document.fileName}.${document.fileType}</title>
            <body style:"overflow: hidden; margin: 0">
              <object width="100%" width="-webkit-fill-available" height="100%" height="-webkit-fill-available" type="application/pdf" data="${url}"></object>
            </body>
          </html>`
        )
      } else {
        vm.$toast.error(vm.$t('Erro ao carregar documento.'))
      }
    } catch (error) {
      console.error('Erro ao carregar documento:', error)
      vm.$toast.error(vm.$t('Erro ao carregar documento.'))
    }
  }

  async getZip(vm) {
    const ids = vm.downloadList.map((file) => file.id)
    if (!ids.length) {
      vm.$toast.error(vm.$t('Nenhum item selecionado para download.'))
      return
    }
    try {
      const response = await this.apiService.post('PopDocument/zip', { ids })
      if (response.statusCode === 200) {
        const byteArray = new Uint8Array(atob(response.content).split('').map(c => c.charCodeAt(0)))
        const blob = new Blob([byteArray], { type: 'application/zip' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'POPs.zip'
        a.click()
        window.URL.revokeObjectURL(url)
      } else {
        vm.$toast.error(vm.$t('Erro ao baixar os arquivos.'))
      }
    } catch (error) {
      console.error('Erro ao baixar os arquivos:', error)
      vm.$toast.error(vm.$t('Erro ao baixar os arquivos.'))
    }
  }
}
